import React from 'react';
import AnalysisTextSection from './AnalysisTextSection';
import { Registry } from '@/graphql/__generated__/onboarding-legal';
import { useNormalizedAntifraudData } from '@/hooks/useNormalizedAntifraudData';
import { NormalizedAntifraudData } from '@/utils/antifraudDataNormalizer';

interface IpAddressProps {
	registry: Registry;
	normalizedData?: NormalizedAntifraudData | null;
}

export const IpAddress: React.FC<IpAddressProps> = ({
	registry,
	normalizedData: propNormalizedData
}) => {
	const hookNormalizedData = useNormalizedAntifraudData(registry);
	const normalizedData = propNormalizedData ?? hookNormalizedData;
	const isUnicoResponse = normalizedData?.isUnico || false;

	if (isUnicoResponse) {
		return null;
	}

	return (
		<div className="space-y-3">
			<AnalysisTextSection
				label="BlacklistedCount"
				value={normalizedData?.ipAddress?.blacklistedCount}
			/>
			<AnalysisTextSection label="IsBlacklisted" value={normalizedData?.ipAddress?.isBlacklisted} />
			<AnalysisTextSection
				label="IsTorConnection"
				value={normalizedData?.ipAddress?.isTorConnection}
			/>
			<AnalysisTextSection
				label="IsVpnConnection"
				value={normalizedData?.ipAddress?.isVpnConnection}
			/>
		</div>
	);
};

export default IpAddress;
